<!-- About Section Start -->
<section class="cyclops about-section" id="about">
  <div class="container">

    <!-- Title -->
    <div class="row mb-5">
      <div class="col-12" >
        <h2 class="section-title gradient-text text-center" style=" color: #b70000;">
          Built for the Missions that Matter 
        </h2>
        <!-- <p class="text-center" style="font-size: 17px;"> Built for the Missions that Matter </p> -->
      </div>
    </div>

    <!-- 3 Columns (First row) -->
    <div class="row text-center">

      <!-- Card 1 -->
      <div class="col-lg-4 col-md-6 mb-4">
        <div class="about-card">
          <div class="about-icon">
             <!-- <span class="material-icons">history</span> -->
              <img src="assets/images/icon_1_history.png" style="width: 80px; height: 80px;" alt="History Icon" class="img-fluid rounded"> 
          </div>
          <h5 class="about-title">History</h5>
          <p class="about-desc">
      CYCLOPS is a DDTC-certified broker, manufacturer, integrator, and global provider of security solutions, with a network spanning over 40 countries.</p>
        </div>
      </div>

      <!-- Card 2 -->
      <div class="col-lg-4 col-md-6 mb-4">
        <div class="about-card">
          <div class="about-icon">
              <!-- <span class="material-icons">psychology</span>
                -->
              <img src="assets/images/icon_2_expertise.png" style="width: 80px; height: 80px;" alt="History Icon" class="img-fluid rounded"> 

          </div>
          <h5 class="about-title">Expertise</h5>
          <p class="about-desc">
      With in-house manufacturing and systems integration capabilities, we deliver UAV/UAS systems, secure communications, surveillance, border security, radars, and MRO services — all field-proven and tailored to mission needs.

          </p>
        </div>
      </div>

      <!-- Card 3 -->
      <div class="col-lg-4 col-md-6 mb-4">
        <div class="about-card">
          <div class="about-icon">
            <!-- <span class="material-icons">directions</span>
              -->
              <img src="assets/images/icon_5_approach.png" style="width: 80px; height: 80px;" alt="History Icon" class="img-fluid rounded"> 

          </div>
          <h5 class="about-title">Approach</h5>
          <p class="about-desc">
          We combine in-house manufacturing, systems integration, and strategic partnerships to deliver tailored, field-proven solutions. From development and engineering to deployment, training, and long-term support, we work side-by-side with our clients to ensure every capability is optimized for their mission, compliant with export regulations, and supported by responsive technical expertise. 
          </p>
        </div>
      </div>

    </div>
   <div class="row text-center">

      <!-- Card 1 -->
      <div class="col-lg-4 col-md-6 mb-4">
        <div class="about-card">
          <div class="about-icon">
              <!-- <span class="material-icons" >visibility</span> -->
              <img src="assets/images/icon_3_mission.png" style="width: 80px; height: 80px;" alt="History Icon" class="img-fluid rounded"> 

          </div>
          <h5 class="about-title">Mission</h5>
          <p class="about-desc">
          CYCLOPS is committed to strengthening national and regional security by designing, manufacturing, and delivering innovative, compliant, and mission-focused defense and security solutions. We partner with governments, defense organizations, and security agencies to provide proven technologies, reliable support, and end-to-end execution where it matters most.
          </p>
        </div>
      </div>

      <!-- Card 2 -->
      <div class="col-lg-4 col-md-6 mb-4">
        <div class="about-card">
          <div class="about-icon">
            <!-- <span class="material-icons">flag</span>
              -->
              <img src="assets/images/icon_4_Vision.png" style="width: 80px; height: 80px;" alt="History Icon" class="img-fluid rounded"> 

          </div>
          <h5 class="about-title">Vision</h5>
          <p class="about-desc">
         To be a trusted global partner recognized for manufacturing excellence, systems integration, and mission-focused defense solutions that enhance security, stability, and operational effectiveness worldwide. </p>
        </div>
      </div>

      <!-- Card 3 -->
      <div class="col-lg-4 col-md-6 mb-4">
        <div class="about-card">
          <div class="about-icon">
           <!-- <span class="material-icons">groups</span> -->
              <img src="assets/images/icon_1_history.png" style="width: 80px; height: 80px;" alt="History Icon" class="img-fluid rounded"> 

          </div>
          <h5 class="about-title">Who We Serve
</h5>
          <p class="about-desc">
        Defense ministries, armed forces, homeland security, intelligence agencies, government contractors, and allied governments across the globe.
          </p>
        </div>
      </div>

    </div>
    <!-- Single Card (Second row) -->
    <!-- <div class="row justify-content-center">
      <div class="col-lg-6 col-md-8 mb-4">
        <div class="about-card">
          <div class="about-icon text-center">
           <span class="material-icons">groups</span>
          </div>
          <h5 class="about-title  text-center">Who We Serve</h5>
          <p class="about-desc text-center">
           CYCLOPS supports defense and government clients across the MENA region and beyond — delivering ITAR-compliant, mission-ready capabilities through in-house manufacturing, systems integration, and tailored security solutions in UAVs, border security, surveillance, communications, and operational support.  
          </p>
        </div>
      </div>
    </div> -->

    <div class="row">
      <div class="col-12 text-center">
        <a routerLink="/about-us" class="btn btn-primary">About Cyclops</a>
      </div>
    </div>

  </div>
</section>
<!-- About Section End -->
